import React from 'react'
import {IssueFile} from '../repository/NatGetOwnershipTransfer'
import {TableRowName} from '../../../../styledComponents/adminPage/Table'
import moment from 'moment'
import {convertToRoomNumberForResident} from '../../../common/util/Natutil'
import {OWNERSHIP_TRANSFER_STATUS} from '../../../../CodeMaster'
import styled from 'styled-components'
import {AdminPrimaryButton} from '../../../../styledComponents/adminPage/Buttons'
import {TableCell, TableRow} from '@mui/material';

interface Props {
    applyId: string
    applyStatus: string
    condominiumName: string
    ridgeName: string
    roomNumber: string
    intermediaryName: string
    issueRepFamilyName: string
    issueRepFirstName: string
    issueDatetime: string
    issueFile: IssueFile
    handleDownloadClick: (path: string) => void
}

export const NatOwnershipTransferIssueDetail: React.FC<Props> = props => {
    const {
        applyId,
        applyStatus,
        condominiumName,
        ridgeName,
        roomNumber,
        intermediaryName,
        issueFile,
        issueRepFamilyName,
        issueRepFirstName,
        issueDatetime,
        handleDownloadClick
    } = props

    const applyStatusMaster = OWNERSHIP_TRANSFER_STATUS.codeToEnumConstants(applyStatus)

    return (
        <>
            <TableRow>
                <TableRowName>ステータス</TableRowName>
                <StyledTableCell colSpan={4} padding={'none'}>
                    <ApplyStatusCell status={applyStatus}>
                        {applyStatusMaster.label}
                    </ApplyStatusCell>
                </StyledTableCell>
            </TableRow>
            <TableRow>
                <TableRowName>申請ID</TableRowName>
                <StyledTableCell colSpan={4}>
                    {applyId}
                </StyledTableCell>
            </TableRow>
            <TableRow>
                <TableRowName>物件名</TableRowName>
                <StyledTableCell colSpan={4}>
                    {condominiumName}
                </StyledTableCell>
            </TableRow>
            <TableRow>
                <TableRowName>部屋番号</TableRowName>
                <StyledTableCell colSpan={4}>
                    {ridgeName} {convertToRoomNumberForResident(roomNumber)}
                </StyledTableCell>
            </TableRow>
            <TableRow>
                <TableRowName>仲介業者名</TableRowName>
                <StyledTableCell colSpan={4}>
                    {intermediaryName}
                </StyledTableCell>
            </TableRow>
            <TableRow>
                <TableRowName>発行ファイル</TableRowName>
                <StyledTableCell colSpan={4} style={{
                    paddingTop: '13.5px',
                    paddingBottom: '13.5px'
                }}>
                    {issueFile.fileName}
                    <DownloadButton
                        onClick={() => handleDownloadClick(issueFile.path)}
                        disabled={applyStatusMaster === OWNERSHIP_TRANSFER_STATUS.COMPLETE ||
                            applyStatusMaster === OWNERSHIP_TRANSFER_STATUS.INVALID}
                    >
                        ダウンロードする
                    </DownloadButton>
                </StyledTableCell>
            </TableRow>
            <TableRow>
                <TableRowName>発行担当者</TableRowName>
                <StyledTableCell colSpan={4}>
                    {issueRepFamilyName} {issueRepFirstName}
                </StyledTableCell>
            </TableRow>
            <TableRow>
                <TableRowName>発行日時</TableRowName>
                <StyledTableCell colSpan={4}>
                    {moment(issueDatetime).format('YYYY-MM-DD HH:mm')}
                </StyledTableCell>
            </TableRow>
            <TableRow>
                <TableRowName>有効期限</TableRowName>
                <StyledTableCell colSpan={4}>
                    {moment(issueDatetime).add(1,'y').format('YYYY-MM-DD')}
                </StyledTableCell>
            </TableRow>
        </>
    )
}

const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding-left: 24px;
    overflow-wrap: anywhere;
      padding-top: 9px;
      padding-bottom: 9px;
  }
`

const ApplyStatusCell = styled.button<{ status?: string }>`
  width: 100px;
  height: 29px;
  border: 0;
  border-radius: 40px;
  background: ${props => props.status === '8' ? 'linear-gradient(0deg, rgba(0, 175, 185, 0.4), rgba(0, 175, 185, 0.4)), #FFFFFF;' :
    props.status === '9' ? 'linear-gradient(0deg, #EDEDED, #EDEDED), #FFFFFF;' :
        'linear-gradient(0deg, rgba(255, 191, 86, 0.4), rgba(255, 191, 86, 0.4)), #FFFFFF;'}
`

const DownloadButton = styled(AdminPrimaryButton)`
    margin-left: 32px;
`
